import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import NewEstimatesV4 from './NewEstimates/NewEstimatesV4';

const EstimateEdit = () => {
    const location = useLocation();
    const { id, customerId, estimateRequestId, type } = useParams();

    const formKey = [location.pathname, id ?? '', customerId ?? '', estimateRequestId ?? '', type ?? ''].join('|');

    return <NewEstimatesV4 key={formKey} />;
};

export default EstimateEdit;
